import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  ar: {
    // Brand
    appName: 'سيركلو',
    tagline: 'تواصل. شارك. اكتشف.',

    // Auth
    login: 'تسجيل الدخول',
    register: 'إنشاء حساب',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    name: 'الاسم',
    phone: 'رقم الهاتف',
    optional: 'اختياري',
    submit: 'إرسال',
    loading: 'جاري التحميل...',
    noAccount: 'ليس لديك حساب؟',
    haveAccount: 'لديك حساب؟',
    welcome: 'مرحباً',
    logout: 'تسجيل الخروج',

    // Bottom nav (social-first)
    home: 'الرئيسية',
    explore: 'استكشاف',
    createPost: 'إضافة منشور',
    notifications: 'الإشعارات',
    profile: 'حسابي',

    // Feed
    feed: 'المنشورات',
    feedEmpty: 'لا توجد منشورات بعد. كن أول من يشارك!',
    like: 'إعجاب',
    liked: 'تم الإعجاب',
    likes: 'إعجاب',
    comments: 'تعليقات',
    addComment: 'أضف تعليقاً...',
    sendComment: 'إرسال',
    deletePost: 'حذف المنشور',
    confirmDelete: 'هل أنت متأكد؟',

    // Create post
    pickMedia: 'اختر صورة أو فيديو',
    captionPlaceholder: 'اكتب وصفاً لمنشورك...',
    publish: 'نشر',
    publishing: 'جاري النشر...',
    alsoShareToStory: 'نشر كستوري أيضًا',
    postCreated: 'تم نشر المنشور',
    postCreatedAndStoryShared: 'تم نشر المنشور والقصة',
    storyShareFailed: 'تم نشر المنشور، لكن تعذّر نشر القصة',
    mediaRequired: 'الرجاء اختيار صورة أو فيديو',

    // Notifications
    notificationsComingSoon: 'الإشعارات قادمة قريباً',
    notificationsHint: 'سيظهر هنا الإعجابات والتعليقات والمتابعون الجدد.',
    activityEmpty: 'لا توجد نشاطات بعد',
    activityEmptyHint: 'عندما يعجب أحدهم بمنشورك أو يعلق عليه، سيظهر هنا.',
    activityLikedYourPost: 'أعجب بمنشورك',
    activityCommentedOnYourPost: 'علّق على منشورك',
    activityFollowedYou: 'بدأ بمتابعتك',
    markAllRead: 'تحديد الكل كمقروء',
    justNow: 'الآن',
    minutesAgo: 'منذ {n} دقيقة',
    hoursAgo: 'منذ {n} ساعة',
    daysAgo: 'منذ {n} يوم',

    // Profile + Settings
    posts: 'منشورات',
    followers: 'متابِعون',
    following: 'يتابع',
    follow: 'متابعة',
    unfollow: 'إلغاء المتابعة',
    followBack: 'متابعة بالمقابل',
    editProfile: 'تعديل الملف',
    settings: 'الإعدادات',
    save: 'حفظ',
    saving: 'جاري الحفظ...',
    saved: 'تم الحفظ',
    nickname: 'اسم المستخدم',
    bio: 'النبذة',
    bioPlaceholder: 'أخبر الناس عن نفسك...',
    privacy: 'الخصوصية',
    privacyPublic: 'عام',
    privacyPrivate: 'خاص',
    languageLabel: 'اللغة',
    arabic: 'العربية',
    english: 'English',
    changePicture: 'تغيير الصورة',
    removePicture: 'إزالة الصورة',
    changePassword: 'تغيير كلمة المرور',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    update: 'تحديث',
    privateProfile: 'حساب خاص',
    privateProfileHint: 'لا يمكن مشاهدة هذا الحساب إلا للمتابعين.',
    noPostsYet: 'لا توجد منشورات بعد',
    closeModal: 'إغلاق',

    // Direct messages
    messages: 'الرسائل',
    messageRequests: 'طلبات الرسائل',
    messageBtn: 'مراسلة',
    activeChats: 'النشطة',
    requestsTab: 'الطلبات',
    noConversations: 'لا توجد محادثات بعد',
    noConversationsHint: 'ابدأ محادثة من ملف أحد المستخدمين.',
    noMessageRequests: 'لا توجد طلبات رسائل',
    noMessageRequestsHint: 'الطلبات الجديدة من المستخدمين ستظهر هنا.',
    typeMessage: 'اكتب رسالة...',
    sendMessage: 'إرسال',
    isTyping: '{name} يكتب الآن...',
    installPromptTitle: 'ثبّت Circleo على جهازك',
    installPromptBody: 'افتح Circleo بنقرة واحدة من شاشة جهازك.',
    installPromptAria: 'تثبيت تطبيق Circleo',
    install: 'تثبيت',
    dismiss: 'إغلاق',
    accept: 'قبول',
    decline: 'رفض',
    requestSentHint: 'تم إرسال هذه الرسالة كطلب. ستتمكن من المتابعة بعد الموافقة.',
    requestPendingHint: 'هذا الطلب قيد المراجعة. اقبله أو ارفضه أدناه.',
    requestDeclinedHint: 'تم رفض الطلب.',
    privateMessageNotice: 'هذا الحساب خاص — رسالتك ستُرسل كطلب.',
    activityNewMessage: 'أرسل لك رسالة',
    activityMessageRequest: 'أرسل طلب رسالة',
    reactions: 'التفاعلات',
    react: 'تفاعل',
    removeReaction: 'إزالة التفاعل',
    emoji: 'رمز تعبيري',

    // Safety / blocking / reporting
    block: 'حظر',
    unblock: 'إلغاء الحظر',
    blocked: 'محظور',
    blockedUsers: 'المستخدمون المحظورون',
    noBlockedUsers: 'لا يوجد مستخدمون محظورون',
    cantInteractBlocked: 'لا يمكنك التفاعل مع هذا المستخدم.',
    blockConfirm: 'حظر هذا المستخدم؟ سيتوقف عن متابعتك ولن يستطيع مراسلتك.',
    unblockConfirm: 'إلغاء حظر هذا المستخدم؟',
    report: 'إبلاغ',
    reportUser: 'الإبلاغ عن المستخدم',
    reportPost: 'الإبلاغ عن المنشور',
    reportComment: 'الإبلاغ عن التعليق',
    reportMessage: 'الإبلاغ عن الرسالة',
    reportReason: 'السبب',
    reportDetails: 'تفاصيل إضافية (اختياري)',
    reportSubmit: 'إرسال البلاغ',
    reportSubmitting: 'جاري الإرسال...',
    reportSubmitted: 'تم استلام بلاغك. شكراً.',
    reportDuplicate: 'تم الإبلاغ سابقاً.',
    reasonSpam: 'إزعاج / محتوى غير مرغوب',
    reasonHarassment: 'تحرش أو مضايقة',
    reasonNudity: 'محتوى جنسي أو عري',
    reasonHate: 'خطاب كراهية',
    reasonMisinformation: 'معلومات مضللة',
    reasonOther: 'سبب آخر',
    mute: 'كتم المحادثة',
    unmute: 'إلغاء الكتم',
    muted: 'مكتومة',
    hideConvo: 'إخفاء المحادثة',
    hideConvoConfirm: 'إخفاء هذه المحادثة من قائمتك؟',
    hideConvoSuccess: 'تم إخفاء المحادثة.',
    moreActions: 'المزيد',
    blockedByThemNotice: 'لا يمكنك التفاعل مع هذا المستخدم حالياً.',
    youBlockedNotice: 'لقد قمت بحظر هذا المستخدم.',
    blockSuccess: 'تم الحظر.',
    unblockSuccess: 'تم إلغاء الحظر.',
    muteSuccess: 'تم كتم المحادثة.',
    unmuteSuccess: 'تم إلغاء كتم المحادثة.',

    // Stories
    stories: 'القصص',
    yourStory: 'قصتك',
    addStory: 'أضف قصة',
    addToStory: 'أضف إلى قصتك',
    newStory: 'قصة جديدة',
    storyPickMedia: 'اختر صورة لقصتك',
    storyPublish: 'نشر القصة',
    storyPublishing: 'جاري النشر...',
    storyPublished: 'تم نشر قصتك',
    noStoriesYet: 'لا توجد قصص نشطة حالياً',
    deleteStory: 'حذف القصة',
    confirmDeleteStory: 'هل تريد حذف هذه القصة؟',
    storyViewers: 'المشاهدون',
    storyViewerCount: 'مشاهدة',
    storyTimeJustNow: 'الآن',
    storyTimeMinutes: 'منذ {n} د',
    storyTimeHours: 'منذ {n} س',

    // Explore / Search / Hashtags
    search: 'بحث',
    searchPlaceholder: 'ابحث عن أشخاص، منشورات، أو وسوم',
    searchTabAll: 'الكل',
    searchTabUsers: 'حسابات',
    searchTabPosts: 'منشورات',
    searchTabTags: 'وسوم',
    searchTooShort: 'اكتب حرفين على الأقل للبدء',
    noResultsFor: 'لا توجد نتائج لـ "{q}"',
    trendingHashtags: 'وسوم رائجة',
    suggestedUsers: 'حسابات مقترحة',
    popularPosts: 'منشورات شائعة',
    hashtagPostsCount: '{n} منشور',
    privateAccount: 'خاص',

    // Feed source toggle / pagination / pull-to-refresh
    feedTabForYou: 'لك',
    feedTabFollowing: 'متابعون',
    feedFollowingEmpty: 'لا توجد منشورات حتى الآن',
    feedFollowingEmptyHint: 'تابع أشخاصاً لرؤية منشوراتهم هنا',
    feedFollowingEmptyCTA: 'استكشاف',
    pullToRefresh: 'اسحب للتحديث',
    releaseToRefresh: 'اترك للتحديث',
    refreshing: 'جاري التحديث...',
    loadingMore: 'تحميل المزيد...',
    youReachedEnd: 'لقد وصلت إلى النهاية',

    // Secondary "Pools" entry (Hasala kept but hidden from main)
    pools: 'الحصالات',
    poolsLater: 'ميزة قادمة',
    wallet: 'المحفظة',
    gems: 'الجواهر',

    // Admin Reports Dashboard
    adminReports: 'الإدارة: البلاغات',
    adminReportsTitle: 'لوحة البلاغات',
    statusOpen: 'مفتوح',
    statusReviewed: 'تمت المراجعة',
    statusDismissed: 'مرفوض',
    allTargets: 'الكل',
    allReasons: 'كل الأسباب',
    targetUser: 'مستخدم',
    targetPost: 'منشور',
    targetComment: 'تعليق',
    targetMessage: 'رسالة',
    reason_spam: 'إزعاج',
    reason_harassment: 'تحرش',
    reason_nudity: 'محتوى غير لائق',
    reason_hate: 'كراهية',
    reason_misinformation: 'تضليل',
    reason_other: 'أخرى',
    reportedAVerb: 'بلّغ عن',
    reportedBy: 'البلاغ من',
    reportedAt: 'تاريخ البلاغ',
    reportDetail: 'تفاصيل البلاغ',
    reason: 'السبب',
    targetType: 'نوع الهدف',
    details: 'تفاصيل',
    targetSnapshot: 'لقطة الهدف',
    status: 'الحالة',
    author: 'الكاتب',
    caption: 'النص',
    media: 'وسائط',
    text: 'النص',
    postId: 'معرّف المنشور',
    sender: 'المُرسِل',
    conversationId: 'معرّف المحادثة',
    adminNote: 'ملاحظة المشرف',
    adminNotePlaceholder: 'سياق إضافي (اختياري)…',
    markReviewed: 'تمت المراجعة',
    dismiss: 'رفض البلاغ',
    markedReviewedAt: 'تمت المراجعة في',
    dismissedAt: 'رُفض في',
    noReports: 'لا توجد بلاغات.',
    unknownUser: 'مستخدم غير معروف',
    adminPreserveHint: 'لا يتم حذف أي بلاغ. السجل دائمًا محفوظ.',

    // Phase 18A — nickname uniqueness
    checking: 'جاري التحقق...',
    nicknameAvailable: 'متاح',
    nicknameTaken: 'هذا الاسم مستخدم بالفعل',
    nicknameTooShort: 'يجب أن يحتوي على 3 أحرف على الأقل',
    nicknameTooLong: 'الحد الأقصى 30 حرفًا',
    nicknameReserved: 'هذا الاسم محجوز',
    nicknameInvalidChars: 'الأحرف المسموح بها فقط: a-z و 0-9 و . _ -',
    nicknameBadBoundary: 'لا يمكن أن يبدأ أو ينتهي بـ . _ -',
    nicknameDoubleSep: 'لا يمكن استخدام رمزي ترقيم متتاليين',
    nicknameAllDigits: 'لا يمكن أن يتكون من أرقام فقط',
    nicknameInvalid: 'اسم المستخدم غير صالح',

    // Misc
    back: 'رجوع',
    close: 'إغلاق',
    cancel: 'إلغاء',
    error: 'حدث خطأ',
  },
  en: {
    // Brand
    appName: 'Circleo',
    tagline: 'Connect. Share. Discover.',

    // Auth
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    name: 'Name',
    phone: 'Phone',
    optional: 'optional',
    submit: 'Submit',
    loading: 'Loading...',
    noAccount: "Don't have an account?",
    haveAccount: 'Have an account?',
    welcome: 'Welcome',
    logout: 'Logout',

    // Bottom nav
    home: 'Home',
    explore: 'Explore',
    createPost: 'Create',
    notifications: 'Activity',
    profile: 'Profile',

    // Feed
    feed: 'Feed',
    feedEmpty: 'No posts yet. Be the first to share!',
    like: 'Like',
    liked: 'Liked',
    likes: 'likes',
    comments: 'comments',
    addComment: 'Add a comment...',
    sendComment: 'Post',
    deletePost: 'Delete post',
    confirmDelete: 'Are you sure?',

    // Create post
    pickMedia: 'Pick a photo or video',
    captionPlaceholder: 'Write a caption...',
    publish: 'Publish',
    publishing: 'Publishing...',
    alsoShareToStory: 'Also share to story',
    postCreated: 'Post created',
    postCreatedAndStoryShared: 'Post created · Story shared',
    storyShareFailed: 'Post created, but the story could not be shared',
    mediaRequired: 'Please pick a photo or video first',

    // Notifications
    notificationsComingSoon: 'Activity coming soon',
    notificationsHint: 'Likes, comments and new followers will show up here.',
    activityEmpty: 'No activity yet',
    activityEmptyHint: 'When someone likes or comments on your post, it shows up here.',
    activityLikedYourPost: 'liked your post',
    activityCommentedOnYourPost: 'commented on your post',
    activityFollowedYou: 'started following you',
    markAllRead: 'Mark all as read',
    justNow: 'just now',
    minutesAgo: '{n}m ago',
    hoursAgo: '{n}h ago',
    daysAgo: '{n}d ago',

    // Profile + Settings
    posts: 'posts',
    followers: 'followers',
    following: 'following',
    follow: 'Follow',
    unfollow: 'Unfollow',
    followBack: 'Follow back',
    editProfile: 'Edit Profile',
    settings: 'Settings',
    save: 'Save',
    saving: 'Saving...',
    saved: 'Saved',
    nickname: 'Username',
    bio: 'Bio',
    bioPlaceholder: 'Tell people a bit about yourself...',
    privacy: 'Privacy',
    privacyPublic: 'Public',
    privacyPrivate: 'Private',
    languageLabel: 'Language',
    arabic: 'العربية',
    english: 'English',
    changePicture: 'Change picture',
    removePicture: 'Remove picture',
    changePassword: 'Change password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    update: 'Update',
    privateProfile: 'Private account',
    privateProfileHint: 'Only followers can view this profile.',
    noPostsYet: 'No posts yet',
    closeModal: 'Close',

    // Direct messages
    messages: 'Messages',
    messageRequests: 'Message Requests',
    messageBtn: 'Message',
    activeChats: 'Active',
    requestsTab: 'Requests',
    noConversations: 'No conversations yet',
    noConversationsHint: 'Start a chat from someone’s profile.',
    noMessageRequests: 'No message requests',
    noMessageRequestsHint: 'New requests from people will show up here.',
    typeMessage: 'Type a message...',
    sendMessage: 'Send',
    isTyping: '{name} is typing…',
    installPromptTitle: 'Install Circleo on your device',
    installPromptBody: 'Open Circleo with one tap from your home screen.',
    installPromptAria: 'Install the Circleo app',
    install: 'Install',
    dismiss: 'Dismiss',
    accept: 'Accept',
    decline: 'Decline',
    requestSentHint: 'This was sent as a request. You can continue the chat once accepted.',
    requestPendingHint: 'This is a message request. Accept or decline below.',
    requestDeclinedHint: 'This request was declined.',
    privateMessageNotice: 'This account is private — your message will be sent as a request.',
    activityNewMessage: 'sent you a message',
    activityMessageRequest: 'sent you a message request',
    reactions: 'Reactions',
    react: 'React',
    removeReaction: 'Remove reaction',
    emoji: 'Emoji',

    // Safety / blocking / reporting
    block: 'Block',
    unblock: 'Unblock',
    blocked: 'Blocked',
    blockedUsers: 'Blocked users',
    noBlockedUsers: 'No blocked users',
    cantInteractBlocked: "You can't interact with this user.",
    blockConfirm: 'Block this user? They will stop following you and cannot message you.',
    unblockConfirm: 'Unblock this user?',
    report: 'Report',
    reportUser: 'Report user',
    reportPost: 'Report post',
    reportComment: 'Report comment',
    reportMessage: 'Report message',
    reportReason: 'Reason',
    reportDetails: 'Additional details (optional)',
    reportSubmit: 'Submit report',
    reportSubmitting: 'Submitting...',
    reportSubmitted: 'Thanks. Your report has been received.',
    reportDuplicate: 'You already reported this.',
    reasonSpam: 'Spam or unwanted content',
    reasonHarassment: 'Harassment or bullying',
    reasonNudity: 'Nudity or sexual content',
    reasonHate: 'Hate speech',
    reasonMisinformation: 'Misinformation',
    reasonOther: 'Other',
    mute: 'Mute conversation',
    unmute: 'Unmute',
    muted: 'Muted',
    hideConvo: 'Hide conversation',
    hideConvoConfirm: 'Hide this conversation from your list?',
    hideConvoSuccess: 'Conversation hidden.',
    moreActions: 'More',
    blockedByThemNotice: "You can't interact with this user right now.",
    youBlockedNotice: "You've blocked this user.",
    blockSuccess: 'Blocked.',
    unblockSuccess: 'Unblocked.',
    muteSuccess: 'Conversation muted.',
    unmuteSuccess: 'Conversation unmuted.',

    // Stories
    stories: 'Stories',
    yourStory: 'Your story',
    addStory: 'Add story',
    addToStory: 'Add to your story',
    newStory: 'New story',
    storyPickMedia: 'Pick a photo for your story',
    storyPublish: 'Publish story',
    storyPublishing: 'Publishing...',
    storyPublished: 'Your story is live',
    noStoriesYet: 'No active stories yet',
    deleteStory: 'Delete story',
    confirmDeleteStory: 'Delete this story?',
    storyViewers: 'Viewers',
    storyViewerCount: 'views',
    storyTimeJustNow: 'now',
    storyTimeMinutes: '{n}m',
    storyTimeHours: '{n}h',

    // Explore / Search / Hashtags
    search: 'Search',
    searchPlaceholder: 'Search people, posts, or hashtags',
    searchTabAll: 'All',
    searchTabUsers: 'Users',
    searchTabPosts: 'Posts',
    searchTabTags: 'Tags',
    searchTooShort: 'Type at least 2 characters to start',
    noResultsFor: 'No results for "{q}"',
    trendingHashtags: 'Trending hashtags',
    suggestedUsers: 'Suggested users',
    popularPosts: 'Popular posts',
    hashtagPostsCount: '{n} posts',
    privateAccount: 'Private',

    // Feed source toggle / pagination / pull-to-refresh
    feedTabForYou: 'For You',
    feedTabFollowing: 'Following',
    feedFollowingEmpty: 'Nothing here yet',
    feedFollowingEmptyHint: 'Follow people to see their posts here',
    feedFollowingEmptyCTA: 'Explore',
    pullToRefresh: 'Pull to refresh',
    releaseToRefresh: 'Release to refresh',
    refreshing: 'Refreshing...',
    loadingMore: 'Loading more...',
    youReachedEnd: "You're all caught up",

    // Secondary "Pools"
    pools: 'Pools',
    poolsLater: 'Coming later',
    wallet: 'Wallet',
    gems: 'Gems',

    // Admin Reports Dashboard
    adminReports: 'Admin: Reports',
    adminReportsTitle: 'Reports dashboard',
    statusOpen: 'Open',
    statusReviewed: 'Reviewed',
    statusDismissed: 'Dismissed',
    allTargets: 'All',
    allReasons: 'All reasons',
    targetUser: 'User',
    targetPost: 'Post',
    targetComment: 'Comment',
    targetMessage: 'Message',
    reason_spam: 'Spam',
    reason_harassment: 'Harassment',
    reason_nudity: 'Nudity',
    reason_hate: 'Hate',
    reason_misinformation: 'Misinformation',
    reason_other: 'Other',
    reportedAVerb: 'reported a',
    reportedBy: 'Reported by',
    reportedAt: 'Reported at',
    reportDetail: 'Report detail',
    reason: 'Reason',
    targetType: 'Target type',
    details: 'Details',
    targetSnapshot: 'Target snapshot',
    status: 'Status',
    author: 'Author',
    caption: 'Caption',
    media: 'Media',
    text: 'Text',
    postId: 'Post ID',
    sender: 'Sender',
    conversationId: 'Conversation ID',
    adminNote: 'Admin note',
    adminNotePlaceholder: 'Add context (optional)…',
    markReviewed: 'Mark reviewed',
    dismiss: 'Dismiss',
    markedReviewedAt: 'Marked reviewed at',
    dismissedAt: 'Dismissed at',
    saving: 'Saving…',
    update: 'Update',
    noReports: 'No reports yet.',
    unknownUser: 'Unknown user',
    adminPreserveHint: 'No report is ever deleted. The record is always preserved.',

    // Phase 18A — nickname uniqueness
    checking: 'Checking…',
    nicknameAvailable: 'Available',
    nicknameTaken: 'Already taken',
    nicknameTooShort: 'Must be at least 3 characters',
    nicknameTooLong: '30 characters maximum',
    nicknameReserved: 'This name is reserved',
    nicknameInvalidChars: 'Only a-z, 0-9, dot, underscore, dash allowed',
    nicknameBadBoundary: 'Cannot start or end with . _ -',
    nicknameDoubleSep: 'No two punctuation characters in a row',
    nicknameAllDigits: 'Cannot be all digits',
    nicknameInvalid: 'Invalid username',

    // Misc
    back: 'Back',
    close: 'Close',
    cancel: 'Cancel',
    error: 'Something went wrong',
  },
};

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState('ar');

  useEffect(() => {
    const savedLang = localStorage.getItem('language') || 'ar';
    setLanguageState(savedLang);
  }, []);

  const setLanguage = (lang) => {
    if (lang !== 'ar' && lang !== 'en') return;
    setLanguageState(lang);
    localStorage.setItem('language', lang);
  };

  const toggleLanguage = () => {
    setLanguage(language === 'ar' ? 'en' : 'ar');
  };

  const t = (key, vars) => {
    let str = translations[language][key] || key;
    if (vars && typeof str === 'string') {
      Object.keys(vars).forEach((k) => {
        str = str.replace(new RegExp('\\{' + k + '\\}', 'g'), String(vars[k]));
      });
    }
    return str;
  };

  return (
    <LanguageContext.Provider
      value={{ language, setLanguage, toggleLanguage, t, isRTL: language === 'ar' }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
